export default "__VITE_ASSET__BOkcXz6s__"